
<template>

	<mymodal ref="modal" title="Переименовать оценочную подгруппу" ok="Переименовать" :reset="reset" :check="check" :submit="submit">

		<b-form-group label="Наименование оценочной подгруппы" label-for="name">

			<b-form-input id="name" v-model="name" required :formatter="first_letter"/>

		</b-form-group>

	</mymodal>

</template>

<script>

import api from "../../../api"
import main_tree from "../../../api/main_tree"
import mymodal from "../../widgets/modal"

export default
{
	props :
	{
		id : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			name : null,

		}
	},

	methods :
	{
		check()
		{
			return !!this.name
		},

		reset()
		{
		},

		execute(old_name)
		{
			this.name = old_name

			this.$refs.modal.execute()
		},

		submit()
		{
			api.call(this, "cadastral_groups", "set_field", { id : this.id, field : "name", value : this.name },
				() =>
				{
					main_tree.create(this)
					
					new Promise((resolve) => {
						this.$emit("need_refresh")
						resolve()
					})
					.then(() => api.show_notification(this, `Наименование группы заменено на "${this.name}"`))
				})
		},

		first_letter(value)
		{
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	}
}

</script>
